import { MouseEventHandler, ReactNode } from "react"
import style from "./Button.module.scss"

// alternate button styles, if no style specified its blue by default
export enum ButtonStyle {
  RED="RED",
}

interface Props {
  children: ReactNode
  disabled?: boolean
  buttonStyle?: ButtonStyle
  title?: string
  onClick: MouseEventHandler
}

export function Button({
  children,
  disabled,
  buttonStyle,
  title,
  onClick,
}: Props) {
  return <button
    className={style.button}
    onClick={onClick}
    disabled={disabled}
    title={title}
    data-style={buttonStyle}
  >
    {children}
  </button>
}